<template>
  <v-tabs
    :value="tab"
    v-bind="$attrs"
    @change="$emit('tabChanged', $event)"
    show-arrows
  >
    <v-tab
      v-for="header in tabsHeader"
      :key="header[headerKey]"
      :href="`#tab-${header[headerText]}`"
    >
      <v-icon
        left
        v-if="header[headerIcon]"
        :color="header[headerIconColor]"
      >{{ header[headerIcon] }}</v-icon>
      {{ header[headerText] }}
    </v-tab>

    <v-tab-item
      v-for="item in tabsHeader"
      :key="item[headerKey]"
      :value="'tab-' + item[headerText]"
    >
      <slot :name="item[headerText]"></slot>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tab: {
      type: String,
      default: ''
    },
    tabsHeader: {
      type: Array,
      required: true
    },
    headerKey: {
      type: String,
      default: 'id'
    },
    headerText: {
      type: String,
      default: 'descricao'
    },
    headerIcon: {
      type: String,
      default: 'icon'
    },
    headerIconColor: {
      type: String,
      default: 'iconColor'
    },
  },
}
</script>

<style>

</style>